import { Paginated, Sortable } from "@ac-expo/api-types";
import { ConsentsFilter } from "./consent.query-keys";

export const emailsConsentsQueryKeys = {
  all: ["emailConsents"] as const,
  lists: (filters?: Sortable<Paginated<ConsentsFilter>>) => [
    ...emailsConsentsQueryKeys.all,
    "lists",
    filters,
  ],
};
